<div class="allteams">All Teams</div>
<app-highcharts-container></app-highcharts-container>

